// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__3yLt0","inputWrap":"styles_inputWrap__1BOxc","input":"styles_input__mU2Pl"};